import { IFilterControl } from "../report-interface";
import { ReferenceData } from "../reference-data-model";

export class DropDownRefDataFilter implements IFilterControl {
    public name: string;
    public type: string = "DropDownReferenceDataFilter";
    public title: string;
    public sizeClass: string;
    public data: Array<ReferenceData>;
    public selectedData: ReferenceData;

    constructor(name: string, title: string, data: Array<ReferenceData>,
                filterOn: string) {
        let selectedItem = new ReferenceData(0, "all", `Show All ${filterOn}`, null);
        data.push(selectedItem);
        this.name = name;
        this.title = title;
        this.data = data;
        this.selectedData = selectedItem;
    }

    public activate(item: ReferenceData) {
        this.selectedData = item;
    }

    get selectedText() {
        return this.selectedData.filterDescription.replace("Show ", "");
    }
}



// WEBPACK FOOTER //
// ./client/app/models/filterControls/drop-down-ref-data-filter-model.ts